const PREFIX = '/reducers/Theme/';

export const SET_THEME = `${PREFIX}SET_THEME`;

export const APP_THEMES = ['light', 'dark', 'yellow'];

export const DEFAULT_THEME = APP_THEMES[1];
